<template>

  <el-row :gutter="40">

    <el-col :span="12" :md="12" :sm="24" :xs="24">
      <h2>{{ $t('title.email-notification') }}</h2>

      <data-form
        :entity="emailForm"
        :fields="emailFields"
        @change="data => emailForm=data"
        @submit="submitEmailNotification"
      >
        <data-table v-if="emailForm.hasEmail"
          model="event-types"
          :columns="['name']"
          :isSelected="isEventTypeSelectedForEmail"
          @selection-change="onSelectForEmail"/>
      </data-form>

    </el-col>

    <el-col :span="12" :md="12" :sm="24" :xs="24" v-if="mobile.push_device_id">
      <h2>{{ $t('title.push-notification') }}</h2>

      <data-form
        :entity="pushForm"
        :fields="pushFields"
        @change="data => pushForm=data"
        @submit="submitPushNotification"
      >
        <data-table v-if="pushForm.wantsPushNotifications"
          model="event-types"
          :columns="['name']"
          :isSelected="isEventTypeSelectedForPush"
          @selection-change="onSelectForPush"/>
      </data-form>

    </el-col>
  </el-row>
</template>

<script>
import { post } from 'providers/http'

export default {
  name: 'notification-settings',
  props: {
    mobile: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      emailForm: {},
      selectedForEmail: [],
      pushForm: {},
      pushFields: {
        'wantsPushNotifications': {
          type: 'switch'
        }
      },
      selectedForPush: []
    }
  },
  computed: {
    emailFields () {
      let emailFields = {
        'hasEmail': {
          type: 'switch'
        }
      }

      if (this.emailForm.hasEmail) {
        emailFields = {
          ...emailFields,
          'email': {
            type: 'email',
            rules: [{ required: true }]
          }
        }
      }

      return emailFields
    }
  },
  methods: {
    isEventTypeSelectedForEmail (eventType) {
      return !!this.mobile.subscriptions.find(s => { s.event_type_id === eventType.id && s.type === 'email' })
    },
    onSelectForEmail (selection) {
      this.selectedForEmail = selection
    },
    isEventTypeSelectedForPush (eventType) {
      return !!this.mobile.subscriptions.find(s => { s.event_type_id === eventType.id && s.type === 'push' })
    },
    onSelectForPush (selection) {
      this.selectedForPush = selection
    },
    async submitEmailNotification () {
      try {
        await post(`api/v1/mobiles/notifications/${this.mobile.id}`, {
          notificationType: 'email',
          eventTypeIds: this.selectedForEmail,
          email: this.emailFields.email
        })

        this.showSuccess('email-notifications-saved')
      }
      catch (err) {
        console.error(err)
      }
    },
    async submitPushNotification () {
      try {
        await post(`api/v1/mobiles/notifications/${this.mobile.id}`, {
          notificationType: 'push',
          eventTypeIds: this.selectedForPush
        })

        this.showSuccess('push-notifications-saved')
      }
      catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// NotificationSettings.vue?08c2a316